const responseLoader = () => {
    const tempOptions = {};
  
    const style = {
      minWidth: "fit-content",
      display: "flex",
      position: "relative",
      justifyContent: "center",
    };
  

    return {
        fetch: (payload, changeHandler) =>{
            if (payload) {
  
                payload.map((option, index) => {
                  const fatherId = option["_id"];
                  return (tempOptions[option["_id"]] = (quesId) =>
                    <div style={style}>
                      {option.responses.map((response) => {
                        return (
                            <>
                            <input onChange={changeHandler}  type="radio" name={quesId} value={response._id}/>
                          <div
                            style={{
                              minWidth: "fit-content",
                              borderRadius: "5px",
                              marginRight: "5px",
                              padding: "5px 10px",
                              backgroundColor: response.color,
                              textTransform: "capitalize",
                            }}
                          >
                            {response.tag}
                          </div>
                            </>)
                      })}
                    </div>
                  
                    
                        )
                }
                );
              }
              return tempOptions;
        }
    }
    
    
  };
  
  export default responseLoader;
  